import { DatePipe } from '@angular/common';
import { Component, ElementRef, Input, OnDestroy, OnInit, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { ApiError, AuthService, BaseVisualizacaoService, ConfigService, DataTablesService, MessageService, Task, TaskService, VisualizacaoStorageService } from '../../../../core';
import { CurrencyFormatPipe, DecimalFormatPipe } from '../../../../shared';
import { ConfigEmpresa, createNomeCliente, createNomeRepresentante } from '../../../configuracoes/app/empresa';
import { IntegrationTituloReceberHttpService } from '../../../configuracoes/integration/titulo-receber';
import { UsuarioPerfil } from '../../../usuario/usuario-perfil';
import { TituloReceberFilter } from '../../filter';
import { TituloReceberIntegracaoErpImportHttpService } from '../../integracoes/erp/import';
import { TituloReceberSituacaoPipe } from '../../situacao';
import { TituloReceberAuthGuardService, TituloReceberSearchHttpService } from '../../services';
import { TituloReceberOptions, TituloReceberOptionsActions } from '../../titulo-receber-options';
import { TituloReceberSearch } from '../../titulo-receber-search';
import { TituloReceberSearchOrderBy } from '../../titulo-receber-search-orderby';
import { TituloReceberSearchTotal } from '../../titulo-receber-search-total';


@Component({
    selector: 'sgt-titulo-receber-table',
    templateUrl : './titulo-receber-table.component.html',
    styleUrls: ['./titulo-receber-table.component.less']
})
export class TituloReceberTableComponent implements OnInit, OnDestroy {
    configEmpresa: ConfigEmpresa;
    perfilUsuario: UsuarioPerfil;
    idUsuario: number;

    @Input() idDataTable = 'tituloReceberTable';
    @Input() visualizacaoStorageKey = 'tituloReceberTableVisualizacao';
    @Input() clearVisualizacaoStorageKeyOnDestroy = false;
    @Input() filter: TituloReceberFilter;
    @Input() optionsVisibility: TituloReceberOptionsActions = {
        canEdit: true,
        canVisualizar: true,
        // Integracao ERP
        canImportOneErp: true,
        canImportOneErp_v1: true
    }

    @Output() editTitulo = new EventEmitter<TituloReceberSearch>();
    @Output() visualizarTitulo = new EventEmitter<TituloReceberSearch>();

    // Total
    isLoadingTotal: boolean;
    total: TituloReceberSearchTotal;

    dataTable: any;
    private columns: any[] = [
        {
            data: null,
            className: 'col-options',
            orderable: false,
            render: (data, type, row, meta) => {
                const entity = data as TituloReceberSearch;

                // Opções
                const options = new TituloReceberOptions();
                // Editar
                options.canEdit = this.optionsVisibility.canEdit && this.tituloReceberAuthGuardService.canEdit(entity.id);
                // Visualizar
                options.canVisualizar = this.optionsVisibility.canVisualizar && this.tituloReceberAuthGuardService.canVisualizar();

                /** Integração ERP */
                // Import One ERP v1
                options.canImportOneErp_v1 = this.optionsVisibility.canImportOneErp_v1 && this.tituloReceberAuthGuardService.canImportOneErp_v1(entity.id, entity.integradoErp);
                // Import One ERP
                options.canImportOneErp = this.optionsVisibility.canImportOneErp && this.tituloReceberAuthGuardService.canImportOneErp(entity.id, entity.idIntegracaoErp);

                let template = '';
                if (options.hasAnyOption()) {
                    template += `
                        <span class="btn-group dropup table-options">
                            <button type="button" title="Opções" class="btn btn-link btn-options dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
                            </button>
                            <div class="dropdown-menu dropdown-menu-titulo-receber">
                    `;
                    // Editar
                    if (options.canEdit) {
                        template +=  `
                            <a class="dropdown-item" id="edit">
                                <i class="fas fa-pencil-alt" aria-hidden="true"></i> Editar
                            </a>
                        `;
                    }

                    // Visualizaar
                    if (options.canVisualizar) {
                        template +=  `
                            <a class="dropdown-item" id="visualizar">
                                <i class="fas fa-search"></i> Visualizar
                            </a>
                        `;
                    }

                    /** Integração ERP */
                    if (options.hasAnyOptionIntegracaoErp()) {
                        template += `
                            <div class="dropdown-divider"></div>
                            <h6 class="dropdown-header">Integração</h6>
                        `;

                        // Import One ERP v1
                        if (options.canImportOneErp_v1) {
                            template +=  `
                                <a class="dropdown-item" id="importOneErp_v1" title="Importar do ERP">
                                    <i class="fas fa-download"></i> Importar do ERP
                                </a>
                            `;
                        }

                        // Import One ERP
                        if (options.canImportOneErp) {
                            template +=  `
                                <a class="dropdown-item" id="importOneErp" title="Importar do ERP">
                                    <i class="fas fa-download"></i> Importar do ERP
                                </a>
                            `;
                        }
                    }

                    template += `
                            </div>
                        </span>
                    `;
                }

                return template;
            },
            createdCell: (td, cellData, rowData, row, col) => {
                if (rowData?.dataAtualizacaoFinanceira) {
                    jQuery(td).addClass('atualizacao-financeira-highlight');
                }

                const dropdown = jQuery(td).find('.btn-group');
                // Ao abrir o dropdown, adicionamos ele no body para exibi-lo corretamente na table
                dropdown.on('show.bs.dropdown', function() {
                    jQuery('body').append(dropdown.css({
                            position: 'absolute',
                            left: dropdown.offset().left,
                            top: dropdown.offset().top
                        }).detach());
                });
                // Ai fechar o dropdown, adicionamos ele novamente a coluna das opções na table
                dropdown.on('hidden.bs.dropdown', function() {
                    jQuery(td).append(dropdown.css({
                        position: 'relative',
                        left: 'auto',
                        top: 'auto'
                    }).detach());
                });

                // Vinculando os eventos de click das opções da tabela
                const myself = this;
                // Opções do dropdown
                dropdown.on('click', 'a', function() {
                    if (this.id === 'edit') {
                        myself.edit(cellData);
                    } else if (this.id === 'visualizar') {
                        myself.visualizar(cellData);
                    } else if (this.id === 'importOneErp_v1') {
                        myself.importOneErp_v1(cellData);
                    } else if (this.id === 'importOneErp') {
                        myself.importOneErp(cellData);
                    }
                });
            }
        },
        {
            data: 'numeroErp',
            className: 'col-numero',
            serverOrderByColumn: TituloReceberSearchOrderBy.NumeroErp,
            createdCell: (td, cellData, rowData: TituloReceberSearch, row, col) => {
                if (rowData?.dataAtualizacaoFinanceira) {
                    jQuery(td).addClass('atualizacao-financeira-highlight');
                }
            }
        },
        {
            data: 'situacao',
            className: 'col-situacao text-center',
            serverOrderByColumn: TituloReceberSearchOrderBy.Situacao,
            render: (data) => this.tituloReceberSituacaoPipe.transform(data),
            createdCell: (td, cellData, rowData: TituloReceberSearch, row, col) => {
                if (rowData?.dataAtualizacaoFinanceira) {
                    jQuery(td).addClass('atualizacao-financeira-highlight');
                }
            }
        },
        {
            data: null,
            className: 'col-pessoa',
            serverOrderByColumn: TituloReceberSearchOrderBy.Pessoa,
            render: (data: TituloReceberSearch, type, row, meta) => {
                if (data) {
                    return `${data.codigoIntegracaoErpPessoa} - ${createNomeCliente(this.configEmpresa.identificacaoCliente, data.nomePessoa, data.nomeFantasiaPessoa)}`;
                }
                return '';
            },
            createdCell: (td, cellData: TituloReceberSearch, rowData, row, col) => {
                if (cellData) {
                    td.title = `${cellData.codigoIntegracaoErpPessoa} - ${createNomeCliente(this.configEmpresa.identificacaoCliente, cellData.nomePessoa, cellData.nomeFantasiaPessoa)}`;
                }
                if (rowData?.dataAtualizacaoFinanceira) {
                    jQuery(td).addClass('atualizacao-financeira-highlight');
                }
            }
        },
        {
            data: 'dataEmissao',
            className: 'col-emissao text-center',
            serverOrderByColumn: TituloReceberSearchOrderBy.DataEmissao,
            render: (data) => this.datePipe.transform(data, 'dd/MM/yyyy'),
            createdCell: (td, cellData, rowData: TituloReceberSearch, row, col) => {
                if (rowData?.dataAtualizacaoFinanceira) {
                    jQuery(td).addClass('atualizacao-financeira-highlight');
                }
            }
        },
        {
            data: 'dataVencimento',
            className: 'col-vencimento text-center',
            serverOrderByColumn: TituloReceberSearchOrderBy.DataVencimento,
            render: (data) => this.datePipe.transform(data, 'dd/MM/yyyy'),
            createdCell: (td, cellData, rowData: TituloReceberSearch, row, col) => {
                if (rowData?.dataAtualizacaoFinanceira) {
                    jQuery(td).addClass('atualizacao-financeira-highlight');
                }
            }
        },
        {
            data: 'dataUltimoPagamento',
            className: 'col-pagamento text-center',
            serverOrderByColumn: TituloReceberSearchOrderBy.DataUltimoPagamento,
            render: (data) => this.datePipe.transform(data, 'dd/MM/yyyy'),
            createdCell: (td, cellData, rowData: TituloReceberSearch, row, col) => {
                if (rowData?.dataAtualizacaoFinanceira) {
                    jQuery(td).addClass('atualizacao-financeira-highlight');
                }
            }
        },
        {
            data: 'diasEmAtraso',
            className: 'col-dias-em-atraso text-right',
            orderable: false,
            createdCell: (td, cellData, rowData: TituloReceberSearch, row, col) => {
                if (rowData?.dataAtualizacaoFinanceira) {
                    jQuery(td).addClass('atualizacao-financeira-highlight');
                }
            }
        },
        {
            data: 'valor',
            className: 'col-valor text-right',
            serverOrderByColumn: TituloReceberSearchOrderBy.Valor,
            render: (data) => this.currencyFormatPipe.transform(data, 1, 2, 2),
            createdCell: (td, cellData, rowData: TituloReceberSearch, row, col) => {
                if (rowData?.dataAtualizacaoFinanceira) {
                    jQuery(td).addClass('atualizacao-financeira-highlight');
                }
            }
        },
        {
            data: 'valorPago',
            className: 'col-valor-pago text-right',
            serverOrderByColumn: TituloReceberSearchOrderBy.ValorPago,
            render: (data) => this.currencyFormatPipe.transform(data, 1, 2, 2),
            createdCell: (td, cellData, rowData: TituloReceberSearch, row, col) => {
                if (rowData?.dataAtualizacaoFinanceira) {
                    jQuery(td).addClass('atualizacao-financeira-highlight');
                }
            }
        },
        {
            data: 'valorRenegociado',
            className: 'col-valor-renegociado text-right',
            serverOrderByColumn: TituloReceberSearchOrderBy.ValorRenegociado,
            render: (data) => this.currencyFormatPipe.transform(data, 1, 2, 2),
            createdCell: (td, cellData, rowData: TituloReceberSearch, row, col) => {
                if (rowData?.dataAtualizacaoFinanceira) {
                    jQuery(td).addClass('atualizacao-financeira-highlight');
                }
            }
        },
        // {
        //     data: 'valorJuros',
        //     className: 'col-valor-juros text-right',
        //     serverOrderByColumn: TituloReceberSearchOrderBy.ValorJuros,
        //     render: (data) => this.currencyFormatPipe.transform(data, 1, 2, 2),
        //     createdCell: (td, cellData, rowData: TituloReceberSearch, row, col) => {
        //         if (rowData?.dataAtualizacaoFinanceira) {
        //             jQuery(td).addClass('atualizacao-financeira-highlight');
        //         }
        //     }
        // },
        {
            data: 'valorSaldo',
            className: 'col-valor-saldo text-right',
            serverOrderByColumn: TituloReceberSearchOrderBy.ValorSaldo,
            render: (data) => this.currencyFormatPipe.transform(data, 1, 2, 2),
            createdCell: (td, cellData, rowData: TituloReceberSearch, row, col) => {
                if (rowData?.dataAtualizacaoFinanceira) {
                    jQuery(td).addClass('atualizacao-financeira-highlight');
                }
            }
        },
        {
            data: 'valorAdimplencia',
            className: 'col-valor-adimplencia text-right',
            serverOrderByColumn: TituloReceberSearchOrderBy.ValorAdimplencia,
            render: (data) => this.currencyFormatPipe.transform(data, 1, 2, 2),
            createdCell: (td, cellData, rowData: TituloReceberSearch, row, col) => {
                if (rowData?.dataAtualizacaoFinanceira) {
                    jQuery(td).addClass('atualizacao-financeira-highlight');
                }
            }
        },
        {
            data: 'percAdimplencia',
            className: 'col-perc-adimplencia text-right',
            serverOrderByColumn: TituloReceberSearchOrderBy.PercAdimplencia,
            render: (data) => `${this.decimalFormatPipe.transform(data, 1, 2, 2)}%`,
            createdCell: (td, cellData, rowData: TituloReceberSearch, row, col) => {
                if (rowData?.dataAtualizacaoFinanceira) {
                    jQuery(td).addClass('atualizacao-financeira-highlight');
                }
            }
        },
        {
            data: null,
            className: 'col-representante',
            visible: !this.authService.isRepresentante(),
            serverOrderByColumn: TituloReceberSearchOrderBy.Representante,
            render: (data: TituloReceberSearch, type, row, meta) => {
                if (data && data.codigoIntegracaoErpRepresentante) {
                    return `${data.codigoIntegracaoErpRepresentante} - ${createNomeRepresentante(this.configEmpresa.identificacaoRepresentante, data.nomeRepresentante, data.nomeFantasiaRepresentante)}`;
                }
                return '';
            },
            createdCell: (td, cellData: TituloReceberSearch, rowData, row, col) => {
                if (cellData && cellData.codigoIntegracaoErpRepresentante) {
                    td.title = `${cellData.codigoIntegracaoErpRepresentante} - ${createNomeRepresentante(this.configEmpresa.identificacaoRepresentante, cellData.nomeRepresentante, cellData.nomeFantasiaRepresentante)}`;
                }
                if (rowData?.dataAtualizacaoFinanceira) {
                    jQuery(td).addClass('atualizacao-financeira-highlight');
                }
            }
        },
        {
            data: 'dataAtualizacaoFinanceira',
            className: 'col-data-atualizacao-financeira text-center',
            serverOrderByColumn: TituloReceberSearchOrderBy.DataAtualizacaoFinanceira,
            render: (data) => this.datePipe.transform(data, 'dd/MM/yyyy'),
            createdCell: (td, cellData, rowData: TituloReceberSearch, row, col) => {
                if (rowData?.dataAtualizacaoFinanceira) {
                    jQuery(td).addClass('atualizacao-financeira-highlight');
                }
            }
        },
        {
            data: 'anotacaoFinanceira',
            className: 'col-pessoa',
            orderable: false,
            createdCell: (td, cellData: string, rowData, row, col) => {
                if (cellData) {
                    td.title = cellData;
                }
                if (rowData?.dataAtualizacaoFinanceira) {
                    jQuery(td).addClass('atualizacao-financeira-highlight');
                }
            }
        }
    ];
    /** Subscriptions das pesquisas. Utilizado para realizar o unsubscribe e cancelar o retorno de requests de pesquissa pendentes antes de iniciar novos requests */
    private searchSubs$: Subscription;

    constructor(private el: ElementRef,
                private activatedRoute: ActivatedRoute,
                private datePipe: DatePipe,
                private currencyFormatPipe: CurrencyFormatPipe,
                private decimalFormatPipe: DecimalFormatPipe,
                private authService: AuthService,
                private baseVisualizacaoService: BaseVisualizacaoService,
                private configService: ConfigService,
                private dataTablesService: DataTablesService,
                private messageService: MessageService,
                private taskService: TaskService,
                private tituloReceberSituacaoPipe: TituloReceberSituacaoPipe,
                private visualizacaoStorageService: VisualizacaoStorageService,
                private tituloReceberAuthGuardService: TituloReceberAuthGuardService,
                private tituloReceberSearchHttpService: TituloReceberSearchHttpService,
                private integrationTituloReceberHttpService: IntegrationTituloReceberHttpService,
                private tituloReceberIntegracaoErpImportHttpService: TituloReceberIntegracaoErpImportHttpService) { }

    ngOnInit(): void {
        this.configEmpresa = this.configService.getEmpresa();
        this.perfilUsuario = this.authService.getPerfilUsuario();
        this.idUsuario = this.authService.getIdUsuario();
    }

    search() {
        // Realizando unsubscribe dos subscriptions atuais e criando um novo para as próximas pesquisas
        this.searchSubs$?.unsubscribe();
        this.searchSubs$ = new Subscription();

        // Obtendo os totais dos títulos a receber
        this.getTotais()
            .then(() => {
                if (!this.dataTable) { // Table ainda não criada
                    // Obtendo os dados da datatable armazenados no storage para sabermos o order e posição do scroll
                    const vs = this.visualizacaoStorageService.get(this.visualizacaoStorageKey);

                    this.createTable(vs?.order)
                        .then(() => {
                            // Realizando scroll para a posição inicial salva
                            if (vs?.scrollerStartPosition > this.dataTable?.scroller?.page()?.end) {
                                this.dataTable?.scroller?.toPosition(vs?.scrollerStartPosition);
                            }
                        });
                } else { // Table já criada, somente damos um reload
                    this.dataTable.ajax.reload();
                }
            })
            .catch(() => {});
    }

    /** Obtem os totais dos títulos a receber */
    private getTotais(): Promise<TituloReceberSearchTotal> {
        return new Promise<TituloReceberSearchTotal>((resolve, reject) => {
            this.searchSubs$.add(this.tituloReceberSearchHttpService.getTotais(this.filter)
                .subscribe(
                    total => {
                        this.total = total;
                        this.isLoadingTotal = false;
                        resolve(total);
                    },
                    (error: ApiError) => {
                        this.isLoadingTotal = false;
                        this.messageService.error(error.message, 'Erro ao obter os totais dos títulos a receber', error);
                        reject();
                    }
                )
            );

        })
    }

    /** Cria a dataTable dos títulos a receber */
    private createTable(initOrder: any[] = null): Promise<void> {
        return new Promise<void>((resolve) => {
            const columnDefs: any[] = [
                {orderable: false, targets: [0]}
            ];

            this.dataTablesService.showTable(`#${this.idDataTable}`, this.dataTable, {
                columnDefs,
                columns: this.columns,
                order: [[4, 'desc']],
                searching: false,
                info: false,
                serverSide: true,
                processing: true,
                deferRender: true,
                scroller: true,
                scrollX: true,
                // stateSave: true,
                ajax: (data, callback, settings) => {
                    // Order By
                    const order = data?.order[0];
                    const orderColumn = this.columns[order?.column];
                    const orderBy = orderColumn?.serverOrderByColumn;
                    const orderByDir = order?.dir;
                    // Limit
                    const limit = data.length;
                    // Offset
                    const offset = data.start;

                    this.searchSubs$.add(this.tituloReceberSearchHttpService.search(this.filter, orderBy, orderByDir, limit, offset)
                        .subscribe(
                            entities => {
                                callback({recordsTotal: this.total?.quantidadeTitulosReceber, recordsFiltered: this.total?.quantidadeTitulosReceber, data: entities});
                            },
                            (error: ApiError) => {
                                this.messageService.error(error.message, 'Erro ao pesquisar os títulos a receber', error);
                                callback({recordsTotal: 0, recordsFiltered: 0, data: []});
                            }
                        )
                    );
                }
            }).then(dataTable => {
                this.dataTable = dataTable;

                setTimeout(() => {
                    // Adicionando evento handler no scroll do body da datatable
                    jQuery(this.el.nativeElement).find('.dataTables_scrollBody').on('scroll', () => {
                        this.visualizacaoStorageService.set(null, null, this.dataTable?.page?.info()?.page, this.dataTable?.order(), this.dataTable?.scroller?.page()?.start, this.visualizacaoStorageKey);
                    });

                    resolve();
                }, 500);
            })
            .catch(() => {});
        });
    }

    /** Atualizando a pesquisa */
    refresh() {
        // Atualizando a pesquisa através da datatable
        this.dataTable?.draw(false);
        // Atualizando os totais
        this.getTotais()
            .then(() => {})
            .catch(() => {});
    }

    edit(entity: TituloReceberSearch) {
        if (!entity) {
            return;
        }
        if (!this.tituloReceberAuthGuardService.canEdit(entity.id)) {
            this.messageService.info(`Você não possui permissão para editar o título a receber ${entity?.numeroErp ?? ''}`, 'Sem permissão para editar');
            return false;
        }

        this.editTitulo.emit(entity);
    }

    /** Abre o modal para visualizar o título a recber */
    visualizar(entity: TituloReceberSearch) {
        if (!entity) {
            return;
        }
        this.visualizarTitulo.emit(entity);
    }

    delete(entity: TituloReceberSearch) { }

    /** Executa a integração de leitura individual dos dados do título no ERP */
    private importOneErp_v1(entity: TituloReceberSearch) {
        if (!entity) {
            return;
        }

        const numeroErp = entity.numeroErp;
        const task = new Task(`Importando título a receber ${numeroErp}`, `Executando importação do título a receber ${numeroErp} do sistema ERP`);
        this.taskService.add(task, task.description);
        this.integrationTituloReceberHttpService.execReadIndividualIntegration(entity.id)
            .subscribe(
                () => {
                    this.taskService.success(task, `Importação do título a receber ${numeroErp} do sistema ERP realizada com sucesso`);
                    this.refresh();
                },
                (error: ApiError) => this.taskService.error(task, error.message, error.cause, error)
            );
    }


    /** Executa a importação do título a receber do ERP */
    private importOneErp(entity: TituloReceberSearch) {
        if (!entity) {
            return;
        }

        const numeroErp = entity.numeroErp;
        const task = new Task(`Importando título a receber ${numeroErp}`, `Executando importação do título a receber ${numeroErp} do ERP`);
        this.taskService.add(task, task.description);
        this.tituloReceberIntegracaoErpImportHttpService.importOne(entity.id)
            .subscribe(
                () => {
                    this.taskService.success(task, `Importação do título a receber ${numeroErp} do sistema ERP realizada com sucesso`);
                    this.refresh();
                },
                (error: ApiError) => this.taskService.error(task, error.message, error.cause, error)
            );
    }

        /** Obtem a coluna de ordenação da table */
        getOrderBy(): number {
            if (!this.dataTable) {
                return null;
            }

            try {
                const order = this.dataTable.order();
                const orderColumn =  this.columns[order[0][0]];
                return orderColumn?.serverOrderByColumn;
            } catch (error) {
                return 0;
            }
        }

        /** Obtem a direção da coluna de ordenação da table */
        getOrderByDir(): string {
            if (!this.dataTable) {
                return null;
            }

            try {
                const order = this.dataTable.order();
                return order ? order[0][1] : null;
            } catch (error) {
                return 'asc';
            }
        }

    ngOnDestroy() {
        this.searchSubs$?.unsubscribe();
        // Removendo evento de scroll do body da datatable
        jQuery(this.el.nativeElement).find('.dataTables_scrollBody').off('scroll');

        if (this.clearVisualizacaoStorageKeyOnDestroy) {
            this.visualizacaoStorageService.clear(this.visualizacaoStorageKey);
        }
    }
}
